const ACTIVE_SOURCE_KEY = "s360-active-token-source";

const normalizeSource = (source) =>
  String(source || "Bot").trim().toLowerCase() || "bot";

const tokenKey = (source) =>
  `token:${encodeURIComponent(normalizeSource(source))}`;

export const setActiveTokenSource = (source) => {
  if (typeof window !== "undefined") {
    window.sessionStorage.setItem(ACTIVE_SOURCE_KEY, normalizeSource(source));
  }
};

export const setTokenForSource = (source, token) => {
  if (typeof window !== "undefined" && token) {
    window.localStorage.setItem(tokenKey(source), token);
    setActiveTokenSource(source);
  }
};

export const getTokenForActiveSource = () => {
  if (typeof window === "undefined") return null;
  const source = window.sessionStorage.getItem(ACTIVE_SOURCE_KEY) || "Bot";
  return window.localStorage.getItem(tokenKey(source));
};
